export class EmbryologyLabRecord {
    table: Array<EmbryologyLabtable>
    husbandName:string;
    age?:number;
    abstinencePeriod:string;
    id:string;
    date:string;
    collectionTime:string;
    liquefactionTime:string;
    appearance: string;
    oocytes: string;
    volume:string;
    viscosity:string;
    ph:string;
    spermCount:string;
    agglutination:string;
    clumping:string;
    granularDebris:string;
    totalMotility:string;
    rapidProgressive:string;
    progressiveMotility:string;
    nonProgressive:string;
    immotile:string;
    normalSperms:string;
    headDefects:string;
    neckMidDefects:string;
    tailDefects:string;
    cytoplasmicDroplet:string;
    epithelialCells:string;
    pusCells:string;
    rbc:string;
    fructoseTest:string;
    hosTest:string;
    impression:string;
    embryologist:string;
    dineBy:string;
    collectedLocation:string;
    collectionMethod:string;
    dateAndTimeofHCG:string;
    protocol:string;
    pickBy:string;
    screeningBy:string;
    transferBy:string;
    embryologistName:string;
    embryoTranferDetails:string;
    catheter:string;
    embryosNo:string;
    discard:string;
    remaining:string;
    blood:string;
    mucus:string;
    asy:string;
    day:string;
    tank:string; canister:string;
    goblet:string;
    device:string;
    totalEmbryos:string;
    strawsNo:string;
    mills:string;
    cleaved:string;
    transferred:string;
    vitrified:string;
    discarded:string;
    caseList: string;
    embryoDetails: Array<EmbryoDetails>;
    embryoValues: Array<EmbryoValues>;

    husbandName1:  string; 
    age1?:  number; 
    anaesthetist:  string; 
    dateAndTimeofHCG1:  string; 

    dateOfOpu:  string; 

    protocol1:  string; 

    opuStartTime:  string; 
    opuEndTime:  string; 
    incubator:  string; 
    leftOvaryNoOfFoliciles:  string; 
    leftOvaryNoOfOocytesRetrieved:  string; 

    leftOvaryGV:  string; 

    leftOvaryMI:  string; 
    leftOvaryMII:  string; 
    leftOvaryNoOfOocyteInjected:  string; 
    leftOvaryNumber:  string; 
    leftOvaryTime:  string; 
    leftOvaryRemark:  string; 

    rightOvaryNoOfFoliciles:  string; 
    rightOvaryNoOfOocytesRetrieved:  string; 
    rightOvaryGV:  string; 
    rightOvaryMI:  string; 
    rightOvaryMII:  string; 
    rightOvaryNoOfOocyteInjected:  string; 

    rightOvaryNumber:  string; 
    rightOvaryTime:  string; 
    rightOvaryRemark:  string; 

    totalNoOfFoliciles:  string; 
   totalNoOfOocytesRetrieved:  string; 
    totalGV:  string; 
    totalMI:  string; 
    totalMII:  string; 
    totalNoOfOocyteInjected:  string; 

    totalNumber:  string; 
    totalTime:  string; 
    totalRemark:  string; 
    // embryologist:  string; 
    witness:  string; 

    //  collectionTime:  string; 
    // volume:  string; 
    liquefationTime:  string; 
    //viscosity:  string; 

    husbandSampleMethodOfPreparation:  string; 
    PreWashCount:  string; 
    preWashMotility:  string; 
    postWashCount:  string; 
    postWashMotility:  string; 
    husbandSampleRemark:  string; 
    donorFrozenMethodOfPreparation:  string; 
    donorFrozenPreWashCount:  string; 
    donorFrozenPreWashMotility:  string; 
    donorFrozenPostWashCount:  string; 
    donorFrozenPostWashMotility:  string; 
    donorFrozenRemark:  string; 
    tesaMethodOfPreparation:  string; 
    tesaPreWashCount:  string; 
    tesaPreWashMotility:  string; 
    tesaPostWashCount:  string; 
    tesaPostWashMotility:  string; 
    tesaRemark:  string; 
    semenDetailsEmbryologist:  string; 
    name:  string; 
    mrdNo:  string; 
    procedure: string; 
    microscopicProcedure: string;
    dateAndTime:  string; 
    performedBy:  string; 
    witnessedBy:  string; 
    spermPreparation:  string; 
    tubesCheck:  string; 
    eggCollection:  string; 
    dishCheck:  string; 
    denudation:  string; 
    dishCheck1:  string; 
    icsi:  string; 
    dishCheck2:  string; 
    embryoTransfer:  string; 
    dishCheck3:  string; 
    freezingOfEggs:  string; 
    dishCheck4: string; 
    procedureList: string;
    witnessSignatureRootPath: string;
    witnessSignature: string;
    witnessBase64Signature: string;
    embryologistSignature: string;
    embryologistBase64Signature: string;
    embryologistSignatureRootPath: string;
    semenEmbryologistSignatureRootPath: string;
    semenEmbryologistSignature: string;
    semenEmbryologistBase64Signature: string;
}
export class EmbryologyLabtable {
  //  day: string;
    date: string;
    totalOocyte: string;
    icsiTime: string;
    ivfTime: string;
    emb: string;
    doctor: string;
    hyaseTime: string;

}

export class EmbryoDetails {
    eggNo: string;
    ivfOrIcsi: string;
    pattern: string;
    day2: string;
    grade1: string;
    frozen1: string;
    day3EmbryoScore: string;
    fertCheck: string;
}

export class EmbryoValues {
    grade2: string;
    frozen2: string;
    blastocyst: string;
    icm: string;
    grade3: string;
    frozen3: string;
    trophectoderm: string;
    grade4: string;

}